/* global ENV_LESS_VARS */
import lessToJs from "less-vars-to-js";

const LESS_VARS = lessToJs(ENV_LESS_VARS, {
  resolveVariables: true,
  stripPrefix: true,
});

function getVar(name) {
  const lessVar = LESS_VARS[name];

  if (lessVar === undefined) {
    console.warn(`lessVar "${name}" does not exist.`);
  }

  return lessVar;
}

export { LESS_VARS, getVar };
